import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { AppConfigState } from 'features/app-config/interfaces';
import { AppConfigDaoService } from 'features/app-config/services';

export const initialAppConfigSlice: AppConfigState = {
  isAppConfigRetrievedSuccessful: false,
};

export const appConfigSlice = createSlice({
  name: 'app-config',
  initialState: initialAppConfigSlice,
  reducers: {
    appConfigRetrievedSuccessful: (state) => {
      state.isAppConfigRetrievedSuccessful = true;
    },
  },
});

export const { appConfigRetrievedSuccessful } = appConfigSlice.actions;
export const appConfigReducer = appConfigSlice.reducer;

export const fetchAppConfig = createAsyncThunk(
  'app-config/fetchAppConfig',
  async (payload, { rejectWithValue }) => {
    try {
      const config = await AppConfigDaoService.getAppConfig();
      return config;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
